var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-faq"},[_c('v-container',[_c('div',{staticClass:"faq-header"},[_c('h2',[_vm._v("Frequently asked questions")]),_c('p',[_vm._v("Everything you need to know about the product and billing.")])]),_c('div',{staticClass:"faq-content"},[_c('FaqComponent')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }